import React, { useState, useMemo } from 'react'

import EditIcon from '@material-ui/icons/Edit'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import { withStyles } from '@material-ui/core/styles'
import { Link, useHistory } from 'react-router-dom'
import LinkButtonWithText from 'Components/Buttons/LinkButtonWithText'
import StyledIconButton from 'Components/Form/StyledIconButton'
import SubmitButton from 'Components/Form/SubmitButton'
import { CONFIG } from 'Config/config'
import { authorization } from 'Module/Auth/Auth'
import { PATHS } from 'Config/Routing/paths'

import CityPage from '../index'
import AmbassadorsPipelineView from './AmbassadorsPipelineView'
import AmbassadorsListView from './AmbassadorsListView'
import EmailPipelineView from './EmailPipelineView'
import Availabilities from './Availabilities'

function Ambassadors(props) {
  const {
    cityId,
    classes,
    cityName,
    countryName,
    cityEmail,
    countryId,
    newcomersMissionsLimit,
    recruitmentOnHold,
    cityTimezone,
    match: { url },
    isOnsiteTrainingEnabled,
    countryCode,
  } = props
  const history = useHistory()
  const viewType = useMemo(
    () => history.location.pathname.split('/')[5] || 'pipeline',
    [history.location.pathname],
  )
  const [stage, setStage] = useState('all')

  const [exportUnfilledUrl, exportUrl] = useMemo(() => {
    const apiKey = authorization.getAPIKey()
    const baseUrl = CONFIG.API_BASE_URL

    // If the city is loaded add that to the spreadsheet name
    const encodeUnfilled = encodeURIComponent(
      cityName
        ? `${cityName.toLowerCase()}-unfilled-availabilities`
        : 'unfilled-availabilities',
    )
    const encodeFilled = encodeURIComponent(
      cityName ? `${cityName.toLowerCase()}-ambassadors` : 'ambassadors',
    )

    return [
      `${baseUrl}/cities/${cityId}/ambassadors/unfilled-availabilities-csv/${encodeUnfilled}?apiKey=${apiKey}`,
      `${baseUrl}/cities/${cityId}/ambassadors/csv/${encodeFilled}?apiKey=${apiKey}`,
    ]
  }, [cityName, cityId, url])

  return (
    <CityPage
      active={props.nav}
      cityId={props.cityId}
      history={props.history}
      match={props.match}
      cityName={cityName}
      newcomersMissionsLimit={newcomersMissionsLimit}
      recruitmentOnHold={recruitmentOnHold}
      breadcrumbs={[{ label: 'Brand Ambassadors' }]}
    >
      <div className="button-container">
        <LinkButtonWithText
          target="_blank"
          href={exportUnfilledUrl}
          label="Unfilled Availabilities"
          title="Export a list of unfilled brand ambassadors availabilities"
        />
        <LinkButtonWithText
          target="_blank"
          href={exportUrl}
          label="Export"
          title="Export a list of brand ambassadors"
        />
      </div>
      <StyledIconButton href={url + '/edit'} className="link-edit-main">
        <EditIcon />
      </StyledIconButton>

      <div className={classes.controls}>
        <ButtonGroup disableElevation color="primary">
          <Link
            to={url + PATHS.cities.ambassadorsList}
            style={{ textDecoration: 'none' }}
          >
            <SubmitButton
              value="List"
              variant={viewType === 'list' ? 'contained' : 'outlined'}
            />
          </Link>
          <Link
            to={url + PATHS.cities.ambassadorsPipeline}
            style={{ textDecoration: 'none' }}
          >
            <SubmitButton
              value="Pipeline"
              variant={viewType === 'pipeline' ? 'contained' : 'outlined'}
            />
          </Link>
          <Link
            to={url + PATHS.cities.ambassadorsEmails}
            style={{ textDecoration: 'none' }}
          >
            <SubmitButton
              value="Communications"
              variant={viewType === 'emails' ? 'contained' : 'outlined'}
            />
          </Link>
          {props.countryCode === 'DE' ? (
            <Link
              to={url + PATHS.cities.availabilities}
              style={{ textDecoration: 'none' }}
            >
              <SubmitButton
                value="Availabilities"
                variant={
                  viewType === 'availabilities' ? 'contained' : 'outlined'
                }
              />
            </Link>
          ) : null}
        </ButtonGroup>
        {viewType !== 'emails' && (
          <Link
            to={url + PATHS.cities.manageOnboardingTimes}
            style={{ textDecoration: 'none' }}
            className="manage-onboarding-button"
          >
            <SubmitButton>Manage Onboarding</SubmitButton>
          </Link>
        )}
      </div>
      {viewType === 'emails' && (
        <EmailPipelineView
          pipelineStage={stage}
          cityId={cityId}
          cityName={cityName}
          countryName={countryName}
          countryId={countryId}
          cityEmail={cityEmail}
          url={url}
          cityTimezone={cityTimezone}
          isOnsiteTrainingEnabled={isOnsiteTrainingEnabled}
        />
      )}
      {viewType === 'list' && (
        <AmbassadorsListView
          cityId={cityId}
          isOnsiteTrainingEnabled={isOnsiteTrainingEnabled}
        />
      )}
      {viewType === 'pipeline' && (
        <AmbassadorsPipelineView
          countryId={countryId}
          cityId={cityId}
          cityTimezone={cityTimezone}
          countryCode={countryCode}
          isOnsiteTrainingEnabled={isOnsiteTrainingEnabled}
          onMailClick={name => {
            history.push(url + PATHS.cities.ambassadorsEmails)
            setStage(name)
          }}
        />
      )}
      {viewType === 'availabilities' && (
        <Availabilities cityId={cityId} isRowExpanded={true} />
      )}
    </CityPage>
  )
}

const styles = {
  controls: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 44px 10px',
  },
}

export default withStyles(styles)(Ambassadors)
